import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {ServerResponseService} from '../server-response.service';

export const notFoundResolver: ResolveFn<boolean> = () => {
  inject(ServerResponseService).setStatusCode(404);
  return true;
};
